import { Component, Input, SimpleChanges } from '@angular/core';
import { GaugeProtectionOption, ORD_GaugeProtection, PatchORDGaugeProtectionDto } from '../../interfaces/request.interface';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Store } from '@ngxs/store';
import { Subject, takeUntil, debounceTime } from 'rxjs';
import { RequestActions } from '../../store/action/request.action';
import { OptionState } from '../../store/state/options.state';

@Component({
    selector: 'app-gaugpadprotection-data',
    templateUrl: './gaugpadprotection-data.component.html',
    styleUrl: './gaugpadprotection-data.component.css',
    standalone: false
})
export class GaugpadprotectionDataComponent {
  @Input() protectionInitial?: ORD_GaugeProtection[];
  @Input() draftId?: number;
  @Input() productLineId?: number;
  @Input() readonly: boolean = false;

  public appGaugePadProtectionData!: FormGroup;
  public options$: GaugeProtectionOption[] = [];
  private destroy$ = new Subject<void>();

  constructor(private fb: FormBuilder, private store: Store) {
    this.appGaugePadProtectionData = this.fb.group({
      selectedProtections: [[]]
    });
  }

  ngOnInit(): void {
    // Subscribe to pre-parsed gauge pad protection options from the store
    this.store.select(OptionState.gaugePadProtectionOptions)
      .pipe(takeUntil(this.destroy$))
      .subscribe((opts: any[]) => {
        if (opts && opts.length) {
          this.options$ = opts.filter(gp => gp.productline_id === this.productLineId && !gp.isObsolete);
          this.patchSelectedFromInitial();
        }
      });

    // Push every form change into the NGXS draft
    this.appGaugePadProtectionData.get('selectedProtections')!.valueChanges.pipe(
      debounceTime(200),
      takeUntil(this.destroy$)
    ).subscribe((selectedValues: string[]) => {
      const selected: PatchORDGaugeProtectionDto[] = (selectedValues || []).map(val => {
        const existing = this.protectionInitial?.find(gp => gp.protection === val);
        return new PatchORDGaugeProtectionDto({
          id:         existing?.id,
          orderId:    this.draftId,
          protection: val
        });
      });

      this.store.dispatch(new RequestActions.PatchRequestDraft({
        draftId:  this.draftId,
        changes: { gaugeProtections: selected }
      }));
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle readonly state changes
    if (changes['readonly']) {
      if (this.readonly) {
        this.appGaugePadProtectionData?.disable();
      } else {
        this.appGaugePadProtectionData?.enable();
      }
    }

    if (changes['protectionInitial'] && this.protectionInitial) {
      this.patchSelectedFromInitial();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private patchSelectedFromInitial(): void {
    if (!this.protectionInitial) return;
    const selectedValues = this.protectionInitial.map(gp => gp.protection!);
    this.appGaugePadProtectionData.get('selectedProtections')?.setValue(selectedValues, { emitEvent: false });

    // Re-apply readonly state after setting values
    if (this.readonly) {
      this.appGaugePadProtectionData?.disable();
    }
  }
}
